import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { Carregando, ErroBox, PageHeader } from '../components/ui';

interface Overview {
  organizacoes: { total: number; ativas: number; suspensas: number };
  eventos: { total: number; ativos: number };
  participantes: number;
  usuariosInternos: number;
  fila: { pendentes: number; falhados: number };
}

export function MasterDashboard() {
  const consulta = useQuery({
    queryKey: ['master', 'overview'],
    queryFn: () => api<Overview>('/master/overview'),
    refetchInterval: 60_000,
  });

  const d = consulta.data;

  return (
    <>
      <PageHeader
        titulo="Plataforma"
        subtitulo="Visão consolidada de todos os clientes MatériaPrimAi."
        acoes={
          <Link className="btn btn-secondary btn-sm" to="/master/clientes">
            <i className="ti ti-building" /> Ver clientes
          </Link>
        }
      />

      {consulta.isPending && <Carregando />}
      {consulta.isError && <ErroBox erro={consulta.error} aoTentar={() => consulta.refetch()} />}

      {d && (
        <>
          <div className="grid grid-4 mb-6">
            <Numero
              valor={d.organizacoes.ativas}
              rotulo="Clientes ativos"
              detalhe={
                d.organizacoes.suspensas > 0
                  ? `${d.organizacoes.suspensas} suspenso(s)`
                  : `${d.organizacoes.total} no total`
              }
              destaque
            />
            <Numero
              valor={d.eventos.ativos}
              rotulo="Eventos ativos"
              detalhe={`${d.eventos.total} já cadastrados`}
            />
            <Numero valor={d.participantes} rotulo="Participantes" detalhe="Em toda a plataforma" />
            <Numero
              valor={d.usuariosInternos}
              rotulo="Equipe MatériaPrimAi"
              detalhe="Contas internas"
            />
          </div>

          <div className="card">
            <div className="section-title">
              <i className="ti ti-stack-2" /> Fila de processamento
            </div>

            <div className="grid grid-2">
              <div>
                <div className="stat-value">{d.fila.pendentes}</div>
                <div className="stat-label">Jobs aguardando</div>
              </div>
              <div>
                <div className={`stat-value${d.fila.falhados > 0 ? ' text-danger' : ''}`}>
                  {d.fila.falhados}
                </div>
                <div className="stat-label">Falhados ou mortos</div>
              </div>
            </div>

            {d.fila.falhados > 0 && (
              <div className="alert alert-danger" style={{ marginTop: 16, marginBottom: 0 }}>
                <i className="ti ti-alert-triangle" />
                Há jobs que esgotaram as tentativas. Nada é reprocessado sozinho — mensagem de
                participante nessa fila não foi entregue.
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}

function Numero({
  valor,
  rotulo,
  detalhe,
  destaque,
}: {
  valor: number;
  rotulo: string;
  detalhe: string;
  destaque?: boolean;
}) {
  return (
    <div className="stat-card">
      <div>
        <div className={`stat-value${destaque ? ' stat-accent' : ''}`}>
          {valor.toLocaleString('pt-BR')}
        </div>
        <div className="stat-label">{rotulo}</div>
      </div>
      <div className="text-dim" style={{ fontSize: 11 }}>
        {detalhe}
      </div>
    </div>
  );
}
